import { Link, useLocation } from 'react-router-dom';

const LINKS = [
  { label: '소개', to: '/company' },
  { label: '공지사항', to: '/company/notice' },
  { label: '자주 묻는 질문', to: '/company/faq' },
];

export default function CompanySubnav() {
  const { pathname } = useLocation();

  const isActive = (to: string) => {
    if (to === '/company') return pathname === '/company';
    return pathname.startsWith(to);
  };

  return (
    <div className="subnav">
      <div className="subnav-inner">
        <span className="subnav-label">Company</span>
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={isActive(link.to) ? 'active' : undefined}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
